'use client';

import { ReactNode, useRef } from 'react';
import { useClickOutside } from '@wishket/yogokit';
import { Sheet } from 'react-modal-sheet';
import { motion } from 'framer-motion';

import { useDeviceCheck } from '@/shared/hooks';

interface ResponsiveListShellProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

const ResponsiveListShell = ({
  isOpen,
  onClose,
  children,
}: ResponsiveListShellProps) => {
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const { isDesktop } = useDeviceCheck();

  useClickOutside(dropdownRef, onClose);

  if (isDesktop) {
    if (!isOpen) return null;
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        className="absolute top-[48px] z-10 desktop:top-[58px]"
        ref={dropdownRef}
      >
        {children}
      </motion.div>
    );
  } else {
    return (
      <Sheet
        isOpen={isOpen}
        onClose={onClose}
        snapPoints={[508]}
        style={{ zIndex: 25 }}
      >
        <Sheet.Container className="react-modal-sheet-container">
          <Sheet.Header />
          <Sheet.Content>
            <Sheet.Scroller>{children}</Sheet.Scroller>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={onClose} />
      </Sheet>
    );
  }
};

export default ResponsiveListShell;
